import i, { css as o } from "styled-components";
const r = i.div.withConfig({
  displayName: "Loading",
  componentId: "sc-13a98jv-0"
})(["align-items:center;border-color:var(--color-bg-default);display:flex;justify-content:center;", ""], ({
  size: t = "md"
}) => {
  const e = typeof t == "number" ? `${t}px` : `var(--size-icon-${t})`;
  return o(["font-size:", ";height:", ";min-height:", ";min-width:", ";width:", ";"], e, e, e, e, e);
});
export {
  r as Loading
};
//# sourceMappingURL=style.es.js.map
